
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intellectual-property-claim",
      function () {
        return require("private-next-pages/intellectual-property-claim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intellectual-property-claim"])
      });
    }
  